import React, {useState} from 'react';
import styles from './kjedeForm.module.css';
import { axiosImageAuthFetch } from '../../../helpers/apiActions/authFetch';
import { API_BASE_URL } from '../../../constants';
import Loader from '../../loader';

export default function AddKjedeForm() {

    const [kjedeName, setKjedeName] = useState('');
    const [discount, setDiscount] = useState(0);
    const [fraktInkludert, setFraktInkludert] = useState(false);
    const [image, setImage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Opprett et nytt FormData-objekt
        const formData = new FormData();

        // Legg til bildet i formData hvis det er valgt
        if (image) {
            formData.append('files.image', image);
        }

        // Legg til resten av dataene i formData
        const data = {
            name: kjedeName,
            discount: discount,
            frakt_inkludert: fraktInkludert
        };

        formData.append('data', JSON.stringify(data));

        try {
            // Send POST-forespørselen til Strapi med formData
            const response = await axiosImageAuthFetch(`${API_BASE_URL}/kjedes`, formData, 'POST');
            console.log(response);
            alert('Kjede opprettet!')
            setIsLoading(false)
            window.location.reload();
        } catch (error) {
            console.error('Feil ved oppretting av kjeden:', error);
            alert('Noe gikk galt. Prøv igjen.');
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            console.log('Valgt fil:', file);  // Logg filen for å sikre at den er valgt
            setImage(file);
        } else {
            console.log('Ingen fil valgt');
        }
    };

    const handleFlickChange = () => {
        setFraktInkludert(!fraktInkludert);
    }

    if(isLoading) {
        return(<Loader />)
    }

    return(
        <div className={styles.container}>
            <div className={styles.header}>Legg til kjede</div>
            <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.formGroup}>
                    <label htmlFor="kjedeName">Kjedenavn:</label>
                    <input 
                        className={styles.input}
                        type="text"
                        id="kjedeName"
                        value={kjedeName}
                        onChange={(e) => setKjedeName(e.target.value)}
                        required
                    />
                </div>
                <div className={styles.formGroup}>
                    <label htmlFor="discount">Rabatt: (i prosent)</label>
                    <input 
                        className={styles.input}
                        type="number"
                        id="discount"
                        value={discount}
                        onChange={(e) => setDiscount(e.target.value)}
                    />
                </div>
                <div className={styles.formGroup}>
                    <label htmlFor="fraktInkludert">Frakt inkludert:</label>
                    <div
                        className={`${styles.flickButton} ${
                        fraktInkludert ? styles.flickOn : styles.flickOff
                        }`}
                        onClick={handleFlickChange}
                    >
            <div
              className={`${styles.flickKnob} ${
                fraktInkludert ? styles.knobRight : styles.knobLeft
              }`}
            ></div>
          </div>
                </div>
                <div className={styles.formGroup}>
                    <label htmlFor="image">Logo:</label>
                    <input 
                        type="file"
                        id="image"
                        onChange={handleImageChange}
                    />
                </div>
                <button type="submit" className={styles.submitButton}>
                    Legg til kjede
                </button>
            </form>
        </div>
    )
}